<template>
  <div>
    <div class="about-box">
      <img :src="imgUrl + 'backround-build.png'" alt="" />
      <div class="about-desc">
        <div class="title">お問い合わせ</div>
        <div class="line"></div>
        <div class="text">日本のTikTok電商運営代行分野で業界の<br />リ-ディングカンパニ-となり</div>
      </div>
    </div>
    <div class="form-box">
      <div class="form-item col-center">
        <div class="label"><span class="red">*</span>氏名</div>
        <div class="value">
          <el-input
            placeholder="必須項目、お名前を入力してください"
            v-model="params.name"
            maxlength="50"
          />
        </div>
      </div>
      <div class="form-item flex col-center">
        <div class="label"><span class="red">*</span>連絡先</div>
        <div class="value">
          <el-input
            placeholder="必須項目、ご連絡先電話番号を入力してください"
            v-model="params.phone"
            maxlength="50"
          />
        </div>
      </div>
      <div class="form-item flex col-center">
        <div class="label"><span class="red">*</span>メールアドレス</div>
        <div class="value">
          <el-input
            placeholder="必須項目、メールアドレスを入力してください"
            maxlength="50"
            v-model="params.email"
          />
        </div>
      </div>
      <div class="form-item flex col-center">
        <div class="label">あなたの考え</div>
        <div class="value">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="300"
            resize="none"
            v-model="params.remark"
            placeholder="あなたの考えを話していただけますか"
          />
        </div>
      </div>
      <div class="btn" @click="submit">提出する</div>
    </div>
  </div>
</template>
<script>
import { addDemand } from '@/api/index'

export default {
  name: 'Navbar',
  data() {
    return {
      imgUrl: process.env.VUE_APP_FILE_URL,
      params: {
        name: '',
        phone: '',
        email: '',
        remark: ''
      }
    }
  },
  methods: {
    submit() {
      if (!this.params.name) {
        return this.$message.warning('氏名を入力してください')
      }
      if (!this.params.phone) {
        return this.$message.warning('連絡先を入力してください')
      }
      if (!this.params.email) {
        return this.$message.warning('メールアドレスを入力してください')
      }
      // if (!this.params.remark) {
      //   return this.$message.warning('あなたの考えを入力してください')
      // }
      addDemand(this.params).then(res => {
        this.$message.success('お問い合わせが完了しました')
        this.params = {
          name: '',
          phone: '',
          email: '',
          remark: ''
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.about-box {
  position: relative;
  img {
    width: 100%;
  }
  .about-desc {
    position: absolute;
    top: 0;
    left: 80px;
    color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: 96px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 4.8px;
      opacity: 0;
      transform: scale(0.95);
      animation: titlePopIn 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;

      @keyframes titlePopIn {
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
    .line {
      width: 163.5px;
      height: 2px;
      background: #ffffff;
      margin: 11px 0 31px;
    }
    .text {
      color: #fff;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
.form-box {
  padding: 40px 200px;
  @media (max-width: $mobile-breakpoint) {
    padding: 50px 8px;
  }
  text-align: center;
  .form-item {
    margin-bottom: 20px;
    display: flex;
    @media (max-width: $mobile-breakpoint) {
      display: block;
      margin-bottom: 20px;
    }
    .red {
      color: #f53f3f;
    }
    .label {
      color: rgba(49, 49, 49, 0.9);
      text-align: right;
      font-size: 20px;
      line-height: 22px; /* 91.667% */
      margin-right: 32px;
      width: 180px;
      @media (max-width: $mobile-breakpoint) {
        width: 110px;
        font-size: 14px;
        margin-bottom: 20px;
        text-align: left;
      }
    }
    .value {
      flex: 1;
    }
    /deep/.el-input__inner {
      border-radius: 16px;
      background: #f5f5f5;
      border: 0;
      height: 64px;
      font-size: 20px;
      font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB',
        'Microsoft YaHei', sans-serif;
      @media (max-width: $mobile-breakpoint) {
        height: 50px;
        font-size: 13px;
      }
    }
    /deep/.el-textarea__inner {
      border-radius: 16px;
      background: #f5f5f5;
      border: 0;
      font-size: 20px;
      line-height: 52px;
      font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB',
        'Microsoft YaHei', sans-serif;
      @media (max-width: $mobile-breakpoint) {
        height: 120px;
        line-height: 42px;
        font-size: 13px;
      }
    }
    ::v-deep .el-input__inner::placeholder,
    ::v-deep .el-textarea__inner::placeholder {
      font-size: 20px;
      color: #95959b;
      font-weight: 400;
      line-height: 52px;
      font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB',
        'Microsoft YaHei', sans-serif;
      @media (max-width: $mobile-breakpoint) {
        font-size: 13px;
        line-height: 42px;
      }
    }
  }

  .btn {
    border-radius: 10px;
    background: #0098fd;
    color: #fff;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: inline-flex;
    padding: 16px 100px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 40px;
    cursor: pointer;
    @media (max-width: $mobile-breakpoint) {
      font-size: 13px;
    }
  }
}
</style>
